import React from 'react';
import './IndexFirstView.css';
import Link from 'gatsby-link';
import { ButtonPlus, ButtonScroll } from '../ButtonSquare';
import logoComdeslezards from './assets/img/logo_comdeslezards.png';
import pictureShowcase from './assets/img/picture_showcase.png';
import pictureEcommerce from './assets/img/picture_ecommerce.png';
import pictureOnmeasureapp from './assets/img/picture_onmeasureapp.png';

const IndexFirstView = () => (
  <div className="background_leaf">
    <Link to="/">
      <img
        className="logo"
        src={logoComdeslezards}
        alt="logo agence web com des lézards"
      />
    </Link>
    <div className="service_container">
      <div>
        <img src={pictureShowcase} alt="illustration site vitrine portfolio" />
        <div className="service_plus_button">
          <ButtonPlus link="/sites-vitrine" theme="light" />
        </div>
        <h2>
          Site vitrine
        </h2>
        <p>
          Vous accordez une grande importance à votre image sur internet ? Vous souhaitez
          présenter votre activité sous le meilleur jour ? Avec un site internet conçu
          exclusivement pour vous par un graphiste expérimenté ? Et performant car
          développé avec les meilleures technologies du moment ? Alors n'hésitez plus à nous contacter, notre agence web saura répondre à vos besoins.
        </p>
      </div>
      <div>
        <img
          src={pictureEcommerce}
          alt="illustration site ecommerce marchand vente en ligne"
        />
        <div className="service_plus_button">
          <ButtonPlus link="/ecommerce" />
        </div>
        <h2>
          eCommerce
        </h2>
        <p>
          Vous vous lancez dans le eCommerce ? Vous souhaitez monter votre activité de vente en ligne ? Le faire rapidement
          grâce à des outils éprouvés et une équipe réactive ? Avoir un partenaire fiable
          avec de nombreuses réalisations réussies à son actif ? L'agence web Com des Lézards saura vous accompagner alors contactez nous.
        </p>
      </div>
      <div>
        <img
          src={pictureOnmeasureapp}
          alt="illustration application sur mesure progiciel"
        />
        <div className="service_plus_button">
          <ButtonPlus link="/applications-sur-mesure" />
        </div>
        <h2
          style={{
            marginTop: '5px',
            marginBottom: '5px',
          }}
        >
          Applications
        </h2>
        <h3>
          sur mesure
        </h3>
        <p>
          Vous cherchez comment gagner du temps dans votre fonctionnement quotidien?
          Gagner en organisation, en fiabilité en efficacité? Tout ça de manière simple
          car développé exclusivement pour vous selon vos besoins? Vous avez cherché mais
          n’avez pas trouvé de solution générique qui corresponde réellement à vos
          besoins? Ou alors elles étaient trop complexes? Notre agence web répond aussi à ce type de besoins avec des compétences techniques élevés et des technologies innovantes.
        </p>
      </div>
    </div>
    <div className="scroll_button">
      <ButtonScroll link="#références" />
    </div>
  </div>
);

export default IndexFirstView;



// WEBPACK FOOTER //
// ./src/components/IndexFirstView/IndexFirstView.jsx